import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TableComp from '../Components/ReusableTable'
import { connect } from 'react-redux'
import { GetPOSearchByVendor } from '../store/actions/vendorActions'
import { downloadFile, GenericUploadVersionFile, uploadFileGeneric } from '../store/actions/fileActions.js'
import { postMapPOAcceptanceToPO } from '../store/actions/poDetailsActions'
import SearchBar from '../Components/SearchBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessFailureModal from '../Components/Success_Failure_Modal';
import AuthHandler from '../Classes/AuthHandler';
import AuthHandlerInstance from '../Classes/AuthHandler'
import env from '../ENV';
import swal from '@sweetalert/with-react';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import FileVersionModal from '../Components/FileVersionModal';
import POCommentPopUp from '../Components/POCommentPopUp';
import toast from 'react-hot-toast';
import { postCommentsForPOs } from '../store/actions/expediting.Actions'
import PaginationComponent from '../Components/PaginationComponent';
import Loading from '../Components/Loader'
import { CSVLink } from "react-csv";
import { GetFilterList } from '../store/actions/masterActions';
import Select, { components } from "react-select"
const LOGIN_URL = env.LOGIN_URL;
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;


function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [day, month, year].join('-');
}


class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      supplierName: "",
      select: true,
      open: false,
      modal: false,
      multiCollapseIndex: "",
      selectedFile: [],
      selectedFileVersion: [],
      comment: "",
      versionId: '',
      documentId: '',
      clickedCondition: false,
      OpenVersionModal: false,
      uploadedId: "",
      POCommentPopUpModal: false,
      varPoId: "",
      varDocumentId: "",
      SearchTerm: '',
      CurrentPage: 1,
      PageSize: 20,
      loading: true,
      totalPos: 0,
      clickedConditional: false,
      csvData: [],
      isShowFilter: false,
      finalpos: [],
      sortByPo: [],
      sortByStatus: [],
      finalstatus: [],
    }

    this.togglebutton = this.togglebutton.bind(this);
    this.modal = this.modal.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.POCommentPopUpModal = this.POCommentPopUpModal.bind(this);

  }

  modal() {
    this.setState({ modal: !this.state.modal });

    if (this.state.modal == true) {
      this.setState(
        { opacity: "" }
      )

    }
    else {
      this.setState(
        { opacity: "0.2" }
      )

    }
  }


  togglebutton = async (Index) => {
    if (this.state.multiCollapseIndex !== Index) {
      await this.setState({ multiCollapseIndex: Index })
    } else {
      await this.setState({ multiCollapseIndex: "" })
    }
  }

  handleFileInput(event) {
    console.log(event)
    let fileList = [...this.state.selectedFile];
    fileList.push(event.target.files[0])
    this.setState({ selectedFile: fileList })

  }

  onclickDownload = async (documentID) => {

    var url = FILESERVER_ROOT_URL + "files/Documents/" + documentID + "/download"
    window.location.href = url

  }

  handlecomment = (e) => {
    this.setState({ comment: e.target.value })
  }

  handleSave = async (elem, POId) => {
    // console.log(this.state.comment, POId,"OKOKOKOKLLLL")
    // return false
    var result = []
    if (this.state.selectedFile.length < 1) {
      swal("Please upload some valid document", { icon: "error" })
      return false;
    }
    if (this.state.clickedCondition == 0) {
      swal("Please select type of acceptance", { icon: "error" })
      return false;
    }
    await this.setState({ loading: true })
    if (elem.POAcceptanceDocumentID) {
      result = await this.props.GenericUploadVersionFile(this.state.selectedFile, elem.POAcceptanceDocumentID, '', AuthHandlerInstance.getUserID());
      toast.success(`${result.results[0].DocumentName}has been uploaded And Send to Purchase Dept.`, {
        duration: 5000
      });
      var versionId = result.results[0].VersionId
      var documentId = result.results[0].DocumentId
      await this.props.postMapPOAcceptanceToPO(versionId, documentId, POId, '', this.state.clickedCondition)
    } else {
      swal("Document is uploading...", { button: false, icon: "info" })
      result = await this.props.uploadFileGeneric(this.state.selectedFile, AuthHandler.getUserID())
      var versionId = result.results[0].VersionId
      var documentId = result.results[0].DocumentId
      await this.props.postMapPOAcceptanceToPO(versionId, documentId, POId, this.state.comment, this.state.clickedCondition)
      await this.props.postCommentsForPOs({
        Comments: this.state.comment,
        UserId: AuthHandler.getUserID(),
        POId: POId,
        DocumentId: documentId,
      })
    }
    var vendorUserEmail = AuthHandler.getUserPayLoad().email;
    await this.props.GetPOSearchByVendor({
      // SearchTerm: searchTerm,
      VendorUserEmail: vendorUserEmail
    })
    this.setState({ selectedFile: [], comment: "", clickedCondition: false, loading: false })
  }

  handleCancel = async () => {
    this.setState({ selectedFile: [], comment: "" })
    document.getElementById("exampleFormControlFile1").value = "";

  }

  handleISearch = (e) => {
    let SearchTerm = e.target.value
    this.setState({
      SearchTerm
    })
    console.log(this.state.SearchTerm)
  }
  // ? handle searching
  handleSearching = async () => {
    await this.setState({ loading: true })
    let totalPos = 0
    var vendorUserEmail = AuthHandler.getUserPayLoad().email;
    let searchData = {
      CurrentPage: 1,
      PageSize: this.state.PageSize,
      SearchTerm: this.state.SearchTerm,
      VendorUserEmail: vendorUserEmail,
      filterbyPo: this.state.sortByPo
    }
    await this.props.GetPOSearchByVendor(searchData)
    await this.setState({ CurrentPage: 1, totalPos: this.props.supplier.recordsets[1][0].totalcount, loading: false })
  }

  handleClick = async (event) => {
    await this.setState({ loading: true })
    let tableData = []
    let totalPos = 0
    console.log(event)
    let currentPage = Number(event.target.id)
    if (!event.target.id) {
      currentPage = event.target.offsetParent.id
    }
    let searchData = {
      CurrentPage: currentPage,
      PageSize: this.state.PageSize,
      SearchTerm: this.state.SearchTerm,
      VendorUserEmail: AuthHandler.getUserPayLoad().email
    }
    this.props.GetPOSearchByVendor(searchData)
    await this.setState({ currentPage: currentPage, totalPos: this.props.supplier.recordsets[1][0].totalcount, loading: false })
  }

  componentDidMount = async () => {
    var vendorUserEmail = AuthHandler.getUserPayLoad().email;
    console.log("🚀 ~ file: Advanced-SubmitPOAcceptance.js ~ line 167 ~ Dashboard ~ componentDidMount ~ vendorUserEmail", vendorUserEmail)
    let searchData = {
      CurrentPage: 1,
      PageSize: this.state.PageSize,
      SearchTerm: this.state.SearchTerm,
      VendorUserEmail: vendorUserEmail
    }
    await this.props.GetPOSearchByVendor(searchData)

    let userPayload = AuthHandlerInstance.getUserPayLoad();

    let csvData = []
    await this.props.supplier.recordsets[0].map(async (element) => {  
      await csvData.push({
        "PO Number": element.POSAPId,
        "Created On": dateFormater(element.POCreationDate),
        "Requested On":  dateFormater(element.RequestedDate),
        "Currency":element.Currency,
        "PO Amount":numberWithCommas((element.POAmount).toFixed(2)),
        "Status":element.StatusName
      })
    })
   await this.setState({ supplierName: userPayload.fullName, totalPos: this.props.supplier.recordsets[1][0].totalcount, loading: false,csvData })

    await this.setState({ supplierName: userPayload.fullName, totalPos: this.props.supplier.recordsets[1][0].totalcount, loading: false })
    await this.getFilterList()
    // console.log("vendorUserEmail",vendorUserEmail)


  }
  onclickConditionForUnconditionalAcceptance = async () => {
    let clicked = 1
    console.log(clicked, "clickedddddddddddddddddd")
    await this.setState({ clickedCondition: clicked })
  }
  onclickCondition = async () => {
    let clicked = 2
    console.log(clicked, "clickedddddddddddddddddd")
    await this.setState({ clickedCondition: clicked })
  }
  async OpenVersionModal(uploadedId) {
    let versionList = [];
    console.log(uploadedId, "this.state.uploadID")
    //
    // if(this.state.OpenVersionModal ==false){
    //     this.setState({opacity:"0.2"})
    // }else{
    //     this.setState({opacity:""})
    // }
    let stateVal = this.state.OpenVersionModal;
    this.setState({ OpenVersionModal: !stateVal, uploadedId: uploadedId });


  }
  POCommentPopUpModal() {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    this.setState({ RetentionDocumentsModal: false });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  togglePOCommentPopUpModal(e) {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal, varPoId: "", varDocumentId: "" });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  rowClick = async (PurchaseOrderId, POAcceptanceDocumentID) => {
    console.log(PurchaseOrderId, POAcceptanceDocumentID, 'incdex')
    await this.setState({ varPoId: PurchaseOrderId, varDocumentId: POAcceptanceDocumentID })
    await this.POCommentPopUpModal()
  }
  toggleFilter = async () => {
    this.setState({ isShowFilter: !this.state.isShowFilter })
  }
  clearFilter = async () => {
    await this.setState({
      isShowFilter: false,
      sortByPo: [],
      searchFor: '',
      POSAPId: [],
    })
    await this.handleSearching()
  }
  handleSelectPO = async (e) => {
    let sortByPo = []
    let POSAPId = []
    if (e.length > 0) {
      e.map((item) => {
        sortByPo.push(item.value)
        POSAPId.push(item)
      })
    }
    await this.setState({ sortByPo, POSAPId })
    await this.handleSearching()
  }
  // handleSelectStatus = async (e) => {
  //   let sortByStatus = []
  //   let StatusName = []
  //   if (e.length > 0) {
  //     e.map((item) => {
  //       sortByStatus.push(item.value)
  //       StatusName.push(item)
  //     })
  //   }
  //   await this.setState({ sortByStatus, StatusName })
  //   await this.handleSearching()
  // }
  getFilterList = async () => {
    await this.props.GetFilterList()
    console.log(this.props.filterList, 'filterList')

    let finalstatus = []
    let finalpos = []

    await this.props.filterList[6].map(async (item) => {
        await finalstatus.push({ label: item.StatusName, value: item.StatusName })
    })
    await this.props.filterList[4].map(async (item) => {
      await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
    })
    let POSAPId = []
    let StatusName = []
    await this.state.sortByPo.map(async (item) => {
      await POSAPId.push({ label: item, value: item })
    })
    await this.state.sortByStatus.map(async (item) => {
        await StatusName.push({ label: item, value: item })
    })
    await this.setState({ finalpos, POSAPId ,StatusName,finalstatus})
  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        //   color: state.isSelected ? 'red' : 'blue',
        padding: "2px 10px",
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "100%",
        minWidth: "max-content",
        zIndex: "999 !important",
      }),
    }
    const { currentPage, posPerpage } = this.state;
    var user = AuthHandlerInstance.getRoles()
    const varPoId = this.state.varPoId
    const varDocumentId = this.state.varDocumentId

    console.log("@@@@@@@@@@@@@@@@", varPoId, varDocumentId)
    // console.log("files",this.props)
    // console.log("Docs",this.props.supplier[0].docs[0])
    // var user = localStorage.getItem("user")

    if (user[5]) {
      //     user = JSON.parse(user)
      //     const role = user.role
      // } 
      // else {
      //     window.location.replace(LOGIN_URL);
      // }


      return (


        <div className="Container-fluid p-4 ">
          {/*----------File version start  */}
          {this.state.uploadedId && this.state.OpenVersionModal && <FileVersionModal uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
          {/*----------File version end  */}
          {/*----------Document comment-------------- */}
          {
            varDocumentId ? (<POCommentPopUp action={this.state.POCommentPopUpModal} togglePOCommentPopUpModal={(e) => this.togglePOCommentPopUpModal(e)} DocumentId={varDocumentId} varPoId={varPoId} path='/ExpeditingPOAcceptanceTrail' />) : null
          }
          {/*----------Document Comment end  */}
          <div className="row">
            <div className="col-md-6 header"><b>{this.state.supplierName}</b></div>
            <div className="col-md-6">
            <CSVLink className="btn2 btn-sms1  rounded-pill float-right" data={this.state.csvData} filename='Supplier-PO' style={{marginTop:8}}>export</CSVLink>
              <Link to={{ pathname: '/Supplier/RequestInspection', state: {} }}>
                <button className="btn2 btn-sms1 mt-2 float-right rounded-pill" type="submit"> Request Inspection </button>
              </Link>
            </div>
          </div>
            <div className="col-5 xs={last} pt-2" style={{paddingLeft: 194,marginLeft: 766}}>
              <SearchBar placeholder="Search" value={this.state.SearchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} />
            </div>
            {this.state.isShowFilter ?
              <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                {/* <div className="col">
                  <Select maxMenuHeight={500} placeholder="Status" isMulti value={this.state.StatusName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalstatus} onChange={(e) => this.handleSelectStatus(e)} />
                </div> */}
                <div className="col">
                  <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                </div>
              </div>
              : null}
          {/* -----Successful modal on licking save button----- */}
          <div>
            <SuccessFailureModal action={this.state.modal} headertitle="Successful" text="ABC" icon='check-circle' iconcolor="green" path='/TestModal' />
          </div>
          {/* -----Successful modal on clicking save button----- */}
          {/* ----- table structure in div form START-------- */}

          {this.state.loading ?
            <Loading />
            :
            <div className="">
              <div className="col-xs-12 ">
                <div className="row  headerbar-vendor " >
                  <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                  <div className="col pt-2 pb-2 borderheaderbar">Created On</div>
                  <div className="col pt-2 pb-2 borderheaderbar">Requested On</div>
                  <div className="col pt-1 pb-2 borderheaderbar">Currency</div>
                  <div className="col pt-1 pb-2 borderheaderbar">PO Amount</div>
                  <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block">Status</div>
                  <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block">Action</div>
                </div>
                {this.props.supplier && this.props.supplier.recordsets.length > 0 && this.props.supplier.recordsets[0].map((element, Index) =>

                  <>
                    <div className={Index % 2 == 0 ? 'row border ' : 'row  background '}
                      onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                      <div className="col pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                      <div className="col pt-2 pb-2 borderheaderbar headeralign">{dateFormater(element.POCreationDate)}</div>
                      <div className="col pt-2 pb-2 borderheaderbar headeralign">{element.RequestedDate ? dateFormater(element.RequestedDate) : ""}</div>
                      <div className="col pt-1 pb-2 borderheaderbar amount-text headeralign">{element.Currency}</div>
                      <div className="col pt-1 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas((element.POAmount).toFixed(2))}</div>

                      <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">
                        {element.isWaivedOff == 1 ? element.StatusName + " By Waived Off" : element.StatusName}
                      </div>
                      <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">
                        {this.state.multiCollapseIndex === Index ?
                          <FontAwesomeIcon icon={"minus-circle"} color="black" title="Collapse" size="lg" className='mr-4' cursor={"pointer"} />
                          : <FontAwesomeIcon icon={"plus-circle"} color="black" title="Expand" size="lg" className='mr-4' cursor={"pointer"} />
                        }
                        {element.POAcceptanceStatus == 7 ?
                          <>
                            <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: element.PurchaseOrderId, poSAPId: element.POSAPId, PoAmount: element.POAmount } }}>
                              <FontAwesomeIcon icon={"sign-in-alt"} color="black" title="View PO Details" size="lg" />
                            </Link>
                            <Link className="pl-4" to={{ pathname: '/Supplier', state: { poId: element.PurchaseOrderId, poSAPId: element.POSAPId, PoAmount: element.POAmount } }}>
                              <FontAwesomeIcon icon={"eye"} color="black" title="View Line Item" size="lg" />
                            </Link>
                          </>
                          :
                          element.POAcceptanceStatus != 4 ?
                            <Link to={{ pathname: '/PoAcceptanceTrail', state: { poId: element.PurchaseOrderId, poSAPId: element.POSAPId, PoAmount: element.POAmount } }}>
                              <FontAwesomeIcon icon={"sign-in-alt"} color="black" title="View PO Details" size="lg" />
                            </Link>
                            :
                            <FontAwesomeIcon icon={"stopwatch"} color="grey" title="PO yet to be approved" size="lg" />
                        }
                      </div>

                    </div>

                    <div style={{ maxWidth: "1600px" }} className={Index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse`}>
                      <div>
                        <div className="row">
                          <div className="col-md-2">
                            <b>PO Document:</b>
                          </div>
                          <div className="col">
                            {element.PODocumentID !== null ?
                              <>
                                <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.PODocumentID)} />
                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + element.PODocumentID + "/download"} target="_blank" download>
                                  <FontAwesomeIcon icon={"file-download"} color={"black"} title="Download" size="lg" />
                                </a>
                                <FontAwesomeIcon className="ml-3" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(element.PurchaseOrderId, element.PODocumentID)} />
                              </>
                              :
                              <FontAwesomeIcon icon={"stopwatch"} color="grey" title="Yet to be upload" size="lg" />
                            }
                          </div>
                          <div className="col-md-2">
                            <b>Location:</b>
                          </div>
                          <div className="col">
                            {element.POLocation}
                          </div>
                        </div>

                        <br></br>
                        {element.POAcceptanceStatus !== 4 && (element.isWaivedOff == null || element.isWaivedOff == 0) ?
                          <>
                            <div className="row">
                              <div className="col-md-2">
                                <b>PO Acceptance:</b>
                              </div>
                              {!element.POAcceptanceDocumentID ?
                                <div className="col">
                                  <div className="col-md-10">
                                    <input type="file" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile1" />
                                  </div>
                                </div> : null}
                              {element.POAcceptanceDocumentID && (element.POAcceptanceStatus == 2 || element.POAcceptanceStatus == 5) ?
                                (<div className="col">
                                  <div className="col-md-10">
                                    <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.POAcceptanceDocumentID)} />
                                    <input type="file" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile1" />
                                  </div>
                                </div>)
                                : element.POAcceptanceDocumentID ?
                                  (<div className="col">
                                    <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.POAcceptanceDocumentID)} />
                                    <FontAwesomeIcon icon={"file-download"} color={"black"} title="Download" size="lg" onClick={() => this.onclickDownload(element.POAcceptanceDocumentID)} />
                                  </div>)
                                  : null}

                              <>
                                {/* <div className="col">
                                    <div className="col-md-10">
                                      <input type="file" className="form-control-file" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile1" />
                                    </div>
                                  </div> */}
                                <div className="col">
                                  <div className="row">
                                    <div className="col-md-1">
                                      {element.POAcceptanceStatus == 3 || element.POAcceptanceStatus == 7 ?
                                        <FontAwesomeIcon icon={"check-circle"} color={"green"} size="x" />
                                        :
                                        element.POAcceptanceStatus == 6 ?
                                          <FontAwesomeIcon icon={"times-circle"} color={"red"} size="x" />
                                          :
                                          <input className="form-check-input" type="checkbox" checked={this.state.clickedCondition == 1 ? true : false} onClick={() => this.onclickConditionForUnconditionalAcceptance()} disabled={element.POAcceptanceStatus == (3 || 5 || 6 || 7) ? true : false} />
                                      }
                                    </div>
                                    <div className="col">
                                      <b>Unconditional Acceptance</b>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-1">
                                      {element.POAcceptanceStatus == 6 ?
                                        <FontAwesomeIcon icon={"check-circle"} color={"green"} size="x" />
                                        :
                                        element.POAcceptanceStatus == 3 || element.POAcceptanceStatus == 7 ?
                                          <FontAwesomeIcon icon={"times-circle"} color={"red"} size="x" />
                                          :
                                          <input className="form-check-input" type="checkbox" checked={this.state.clickedCondition == 2 ? true : false} onClick={() => this.onclickCondition()} disabled={element.POAcceptanceStatus == (3 || 5 || 6 || 7) ? true : false} />
                                      }
                                    </div>
                                    <div className="col">
                                      <b>Conditional Acceptance</b>
                                    </div>
                                  </div>
                                </div>
                              </>



                            </div>

                            <br></br>

                            <div className="row">
                              <div className="col-md-2">
                                <b>Comments <em>(if any)</em>:</b>
                              </div>
                              {element.POAcceptanceDocumentID ? (
                                <div className="col">
                                  <FontAwesomeIcon className="align-middle" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(element.PurchaseOrderId, element.POAcceptanceDocumentID)} />
                                </div>
                              ) : element.POAcceptanceStatus == 5 ?
                                (<div className="col-md-9">
                                  <textarea className="form-control" rows="2" value={this.state.comment} onChange={this.handlecomment}></textarea>
                                </div>)
                                : null}
                            </div>

                            <br></br>

                            <div className="row">
                              {(element.POAcceptanceDocumentID == null && (element.POAcceptanceStatus == 2 || element.POAcceptanceStatus == 5)) || (element.POAcceptanceDocumentID && (element.POAcceptanceStatus == 2 || element.POAcceptanceStatus == 5)) ?
                                <div className="row buttonpadding_submitPO">
                                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right rounded-pill" onClick={(e) => this.handleCancel()}>Cancel</button>
                                  <button className="btn2  btn-sms4 mt-2 ml-4 float-right rounded-pill" onClick={(e) => this.handleSave(element, element.PurchaseOrderId)}>Send To Purchaser</button>
                                </div>
                                : null}
                            </div>
                          </> : element.POAcceptanceStatus !== 4 && element.POAcceptanceStatus !== 7 ?
                            <>
                              <div className="row">
                                <div className="col-md-2">
                                  <b>PO Acceptance:</b>
                                </div>
                                {element.POAcceptanceDocumentID && element.POAcceptanceStatus == 2 ?
                                  (<div className="col">
                                    <div className="col-md-10">
                                      <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.POAcceptanceDocumentID)} />
                                      <input type="file" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile1" />
                                    </div>
                                  </div>)
                                  : element.POAcceptanceDocumentID ?
                                    (<div className="col">
                                      <FontAwesomeIcon className={"mr-3"} icon={"code-branch"} color={"black"} title="Document Version" size="lg" onClick={() => this.OpenVersionModal(element.POAcceptanceDocumentID)} />
                                      <FontAwesomeIcon icon={"file-download"} color={"black"} title="Download" size="lg" onClick={() => this.onclickDownload(element.POAcceptanceDocumentID)} />
                                    </div>)
                                    :
                                    (<div className="col">
                                      <div className="col-md-10">
                                        <input type="file" className="form-control-file" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile1" />
                                      </div>
                                    </div>)}
                                <div className="col">
                                  <div className="row">
                                    <div className="col-md-1">
                                      {element.POAcceptanceStatus == 3 || element.POAcceptanceStatus == 7 ?
                                        <FontAwesomeIcon icon={"check-circle"} color={"green"} size="x" />
                                        :
                                        element.POAcceptanceStatus == 6 ?
                                          <FontAwesomeIcon icon={"times-circle"} color={"red"} size="x" />
                                          :
                                          <input className="form-check-input" type="checkbox" checked={this.state.clickedCondition ? true : false} onClick={() => this.onclickConditionForUnconditionalAcceptance()} disabled={element.POAcceptanceStatus == (3 || 5 || 6 || 7) ? true : false} />
                                      }
                                    </div>
                                    <div className="col">
                                      <b>Unconditional Acceptance</b>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-1">
                                      {element.POAcceptanceStatus == 6 ?
                                        <FontAwesomeIcon icon={"check-circle"} color={"green"} size="x" />
                                        :
                                        element.POAcceptanceStatus == 3 || element.POAcceptanceStatus == 7 ?
                                          <FontAwesomeIcon icon={"times-circle"} color={"red"} size="x" />
                                          :
                                          <input className="form-check-input" type="checkbox" checked={this.state.clickedConditional ? true : false} onClick={() => this.onclickCondition()} disabled={element.POAcceptanceStatus == (3 || 5 || 6 || 7) ? true : false} />
                                      }
                                    </div>
                                    <div className="col">
                                      <b>Conditional Acceptance</b>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <br></br>

                              <div className="row">
                                <div className="col-md-2">
                                  <b>Comments <em>(if any)</em>:</b>
                                </div>
                                {element.POAcceptanceDocumentID ? (
                                  <div className="col">
                                    <FontAwesomeIcon className="align-middle pr-2" icon={"sms"} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(element.PurchaseOrderId, element.POAcceptanceDocumentID)} />
                                  </div>
                                ) :
                                  (<div className="col-md-9">
                                    <textarea className="form-control" rows="2" value={this.state.comment} onChange={this.handlecomment}></textarea>
                                  </div>)}
                              </div>

                              <br></br>

                              <div className="row">
                                {element.POAcceptanceDocumentID == null || (element.POAcceptanceDocumentID && element.POAcceptanceStatus == 2) ?
                                  <div className="row buttonpadding_submitPO">
                                    <button className="btn2 btn-sms3 mt-2 ml-4 float-right rounded-pill" onClick={(e) => this.handleCancel()}>Cancel</button>
                                    <button className="btn2  btn-sms4 mt-2 ml-4 float-right rounded-pill" onClick={(e) => this.handleSave(element, element.PurchaseOrderId)}>Send To Purchaser</button>
                                  </div>
                                  : null}
                              </div>
                            </>
                            : null}

                      </div>
                    </div>
                  </>

                )}



              </div>
              <div className="float-right">
                <PaginationComponent filteredTodos={this.props.supplier.recordsets[0]} currentPage={currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} />
              </div>
            </div>
          }
          {/* -----table structure in div form END-------- */}
        </div>

      )
    }
  }
}

const mapStateToProps = (state) => ({
  supplier: state.vendorReducer.getPOSearchByVendor,
  results: state, file: state.file, poDetails: state.poDetails, postSupplier: state.inspectionReducer, filterList: state.masterReducer.filterList
})
export default connect(mapStateToProps, { GetFilterList, GetPOSearchByVendor, postMapPOAcceptanceToPO, GenericUploadVersionFile, postCommentsForPOs, uploadFileGeneric })(Dashboard)
